// extracted by mini-css-extract-plugin
module.exports = {"pricingtable":"pricing-styles-module--pricingtable--JqaIQ","svg":"pricing-styles-module--svg--3WDVU","extraInfo":"pricing-styles-module--extraInfo--3AyOT"};